<template>
    <cs-modal
        :data-component="$options.name"
        channel="real-estate"
        headerText="Suche abonnieren"
        :visible="isVisible"
        @update:visible="emitClosedModalEvent"
    >
        <form
            v-show="!showSuccessView"
            id="formMailAgent"
            novalidate
            @submit.prevent="onSubmit"
        >
            <div class="contentBox">
                <span class="block text-text-l font-bold mb-16">Deine Suchkriterien</span>
                <div class="flex flex-wrap gap-8">
                    <cs-tag
                        v-for="tag in tags"
                        :key="tag"
                        >{{ tag }}
                    </cs-tag>
                </div>
            </div>
            <div class="contentBox">
                <span class="block text-text-l font-bold mb-16">Wie oft möchtest du benachrichtigt werden?</span>
                <div class="relative flex flex-col mb-32">
                    <cs-radio-button
                        v-for="intervalOption in intervalOptions"
                        :key="intervalOption.value"
                        :value="intervalOption.value"
                        class="mr-30"
                        name="notification"
                        :modelValue="formData.interval.value"
                        @update:modelValue="onChangeInterval"
                        >{{ intervalOption.label }}
                    </cs-radio-button>
                    <ms-nudge
                        ref="nudge"
                        :visible="showNudge"
                        @closeNudge="closeNudge"
                        >Erhöhe mit stündlichen Benachrichtigungen deine Chance auf eine Besichtigung.
                    </ms-nudge>
                </div>
                <span class="block text-text-l font-bold mb-16">Wie lautet deine E-Mail-Adresse? </span>
                <cs-input-field
                    v-model="formData.email"
                    class="mb-24"
                    :autoFocus="false"
                    :errorMsg="showErrorMessage ? 'Bitte gib eine gültige E-Mail Adresse an.' : ''"
                    label="E-Mail-Adresse*"
                />
                <div class="text-color-greyscale-400 text-caption">
                    Wir senden dir kostenlos E-Mails mit passenden Inseraten zu deiner Immobiliensuche, die du jederzeit
                    auch per E-Mail an
                    <a
                        href="mailto:immobilien@meinestadt.de"
                        class="cursor-pointer hover:underline"
                        >immobilien@meinestadt.de</a
                    >
                    widerrufen kannst. Dabei gilt unsere
                    <cs-copy-text-link
                        :href="privacyPoliceUrl"
                        target="_blank"
                        >Datenschutzerklärung</cs-copy-text-link
                    >.
                </div>
            </div>
            <span class="text-caption">Bitte fülle alle mit * gekennzeichneten Felder aus</span>
        </form>
        <div
            v-show="showSuccessView"
            class="contentBox text-center"
            data-test-id="successPage"
        >
            <ms-form-success-mail-agent class="m-auto mb-16" />
            <span class="block text-h3 font-bold mb-8">Fast geschafft!</span>
            <p class="text-text-l">
                Wir haben dir soeben eine E-Mail geschickt. Bitte klicke nur noch auf den Bestätigungslink. Vielen Dank
                und viel Erfolg bei der Suche.
            </p>
        </div>
        <template
            v-if="!showSuccessView"
            #buttons
        >
            <cs-primary-button
                class="w-full screen-m:w-fit"
                form="formMailAgent"
                type="submit"
                :isDisabled="formData.email === ''"
                :isCentered="true"
                >Suche abonnieren
            </cs-primary-button>
        </template>
    </cs-modal>
</template>
<script lang="ts" src="./MsMailAgentModal.ts" />
<style scoped>
.contentBox {
    @apply p-16 mb-16 rounded-10 bg-white shadow last:mb-0;
}
</style>
